export const DeadLetterMessage = (json: IDeadLetterMessage): IDeadLetterMessageModel => {
	const { message_id, failed_at, operation_key, exception_message, production_plan_date, ...rest } = json

	return {
		...rest,
		messageId: message_id,
		failedAt: new Date(failed_at),
		operationKey: operation_key ?? null,
		exceptionMessage: exception_message,
		productionPlanDates: production_plan_date ? production_plan_date.split(',') : [],
	}
}

export const DeadLetterOperationOptions = (json?: IDeadLetterFiltersMeta['filters']): IDeadLetterOperationOption[] =>
	json?.operations ?? []
